import { useState, useRef, useEffect, useCallback } from 'react';

/**
Dropdown Hooks, like the file name says
Handles management of open/close state
Adding/removing CSS classes to body/html
*/

function useDropdownState(params = {}) {
  const {
    open: initialOpen,
    onToggle
  } = params; // state for open/close state

  const [open, setOpen] = useState(initialOpen); // ref for dropdown

  const componentRef = useRef(null);
  useEffect(() => {
    setOpen(initialOpen);
  }, [initialOpen]); // reset state if open prop changes

  const onClickOutside = useCallback(e => {
    if (open && !componentRef.current.contains(e.target)) {
      if (typeof onToggle === 'function') onToggle(false);
      setOpen(false);
    }
  }, [setOpen, onToggle, open]);
  useEffect(() => {
    window.addEventListener('pointerdown', onClickOutside);
    return () => window.removeEventListener('pointerdown', onClickOutside);
  }, [onClickOutside]); // listener for when user clicks outside dropdown

  function toggleDropdown() {
    if (typeof onToggle === 'function') onToggle(!open);
    setOpen(!open);
  }

  function openDropdown() {
    onToggle(open);
    setOpen(true);
  }

  function closeDropdown() {
    onToggle(false);
    setOpen(false);
  }

  return {
    open,
    setOpen,
    componentRef,
    openDropdown,
    closeDropdown,
    toggleDropdown
  };
}

export default useDropdownState;
